import { DocumentInterface } from '@/services/folders/types'
import { createContext, useContext, useState } from 'react'
import { useAuthContext } from '.'

/* eslint-disable react-refresh/only-export-components -- context module */

export interface FinderContextType {
    selectedItems: DocumentInterface[]
    setSelectedItems: (items: DocumentInterface[]) => void
}

const defaultFinderContext: FinderContextType = {
    selectedItems: [],
    setSelectedItems: () => {},
}

const FinderContext = createContext<FinderContextType>(defaultFinderContext)

export const useFinderContext = () => {
    return useContext(FinderContext)
}

export default function FinderContextProvider({ children }: { children: React.ReactNode }) {
    const { org } = useAuthContext()
    const [selectedItems, setSelectedItems] = useState<DocumentInterface[]>([])

    const filteredSelectedItems = selectedItems.filter(item => item.org === org?.id)

    return (
        <FinderContext.Provider value={{ selectedItems: filteredSelectedItems, setSelectedItems }}>
            {children}
        </FinderContext.Provider>
    )
}
